import { toLowHighRange } from "@cornerstonejs/core/utilities/windowLevel";
import dicomImageLoader from '@cornerstonejs/dicom-image-loader';
import { getViewport, setVOILUTRangeForMPR ,getMPRViewport } from "./CornerstoneViewportService";
import * as cornerstone from "@cornerstonejs/core";

// deprecated in 2.0
//dicomImageLoader.external.cornerstone = cornerstone;

export const convolute = async (activeViewport) => {
  const kernel = [
    [-1, -1, -1],
    [-1, 9, -1],
    [-1, -1, -1],
  ];
  // const kernel = [
  //   [0, -1, 0],
  //   [-1, 5, -1],
  //   [0, -1, 0],
  // ];
  const multiplier = 1;

  const promise = dicomImageLoader.webWorkerManager.addTask(
    "convolveTask",
    {
      pixelData: activeViewport.csImage.getPixelData(),
      kernel: kernel,
      multiplier: multiplier,
      imageFrame: {
        typedArrayName: activeViewport.csImage.getPixelData().constructor.name,
        width: activeViewport.csImage.width,
        height: activeViewport.csImage.height,
      },
    },
    -8
  ).promise;
  promise.then(function (result) {
    result.pixelData = new Float32Array(result.pixelData);
    const sharpenedImage = {
      color: false,
      columns: activeViewport.csImage.columns,
      rows: activeViewport.csImage.rows,
      width: activeViewport.csImage.width,
      height: activeViewport.csImage.height,
      imageId: new Date().toISOString(),
      maxPixelValue: result.minMax.max,
      minPixelValue: result.minMax.min,
      windowWidth: activeViewport.csImage.windowWidth,
      windowLevel: activeViewport.csImage.windowLevel,
      sizeInBytes: activeViewport.csImage.sizeInBytes,
      render: activeViewport.csImage.render,
      slope: activeViewport.csImage.slope,
      intercept: activeViewport.csImage.intercept,
      invert: activeViewport.csImage.invert,
      getPixelData: function () {
        return result.pixelData;
      },
    };
    activeViewport.csImage = sharpenedImage;
    activeViewport.render();
  });
};

export const setVOILUTRange = async (viewportIndex, ww, wc, convoluteFlag, isMPRActive) => {
  const range = toLowHighRange(ww, wc);
  if(isMPRActive) {
    await setVOILUTRangeForMPR(range, convoluteFlag)
    return;
  }
  const activeViewport = await getViewport(viewportIndex);
  activeViewport.setProperties({
    voiRange: range,
  });
  activeViewport.render();
  if (convoluteFlag) {
    convolute(activeViewport);
  }
};

export const resetVOILUTRange = async (viewportIndex, range, isMPRActive = false) => {
// export const resetVOILUTRange = async (viewportIndex, range) => {
  console.log("resetVOILUTRange called for viewportIndex:",viewportIndex," with range: ",range);
  //const activeViewport = await getViewport(viewportIndex);
  const activeViewport = isMPRActive 
  ? await getMPRViewport(viewportIndex)
  : await getViewport(viewportIndex);
  console.log("activeViewport: inside the resetVOILUTRange ", activeViewport);
  activeViewport.setProperties({
    voiRange: range,
  });
  activeViewport.render();
};
